/** Toast notifications - non-blocking, stacked above the bottom nav. */

import { h, clear } from '../../utils/dom.js';

const container = () => document.getElementById('toasts');

export function toast(message, { kind = 'info', timeout = 4200 } = {}) {
  const host = container();
  if (!host) return () => {};
  const el = h('div', { class: `toast toast--${kind}` }, [String(message)]);
  host.append(el);
  const remove = () => {
    el.remove();
  };
  const timer = timeout > 0 ? setTimeout(remove, timeout) : null;
  el.addEventListener('click', () => {
    if (timer) clearTimeout(timer);
    remove();
  });
  return remove;
}

export const toastOk = (message, options) => toast(message, { kind: 'ok', ...options });
export const toastWarn = (message, options) => toast(message, { kind: 'warn', ...options });
export const toastError = (message, options) => toast(message, { kind: 'error', timeout: 7000, ...options });

export function clearToasts() {
  const host = container();
  if (host) clear(host);
}
